@if ((breadcrumbs$ | async); as breadcrumbs) { @if (breadcrumbs.length) {
  <nav class="breadcrumb-nav" aria-label="Breadcrumb">
    <ol class="breadcrumb-list">
      <li class="breadcrumb-item home">
        <a routerLink="/dashboard" class="breadcrumb-link home-link">
          <hugeicons-icon [icon]="homeIcon" [size]="16" color="currentColor"></hugeicons-icon>
        </a>
        <span class="separator">
          <hugeicons-icon [icon]="arrowRightIcon" [size]="14" color="currentColor"></hugeicons-icon>
        </span>
      </li>
      @for (breadcrumb of breadcrumbs; track $index; let last = $last) {
        <li class="breadcrumb-item">
          @if (!last) {
            <a [routerLink]="breadcrumb.url" class="breadcrumb-link">{{ breadcrumb.label }}</a>
          }
          @if (last) {
            <span class="breadcrumb-current">{{ breadcrumb.label }}</span>
          }
          @if (!last) {
            <span class="separator">
              <hugeicons-icon [icon]="arrowRightIcon" [size]="14" color="currentColor"></hugeicons-icon>
            </span>
          }
        </li>
      }
    </ol>
  </nav>
} }